<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part">
<h2><span class="h2-inner">Act One</span></h2>
<h3 class="firstInSection">Alexandria and Tarsus</h3>
<h3>41–40 B.C.</h3>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?4f526a98